/*
 * Paper pages reserve space above their content in `site-surface.css`.
 * Keep the fixed header within that band and open its panels below it.
 */
.bar {
  /* The marketing nav's measures, so both navs line up with the page body. */
  --h: 65px;
  --gutter: 64px;
  --inline: max(var(--gutter), calc((100% - 1200px) / 2 + var(--gutter)));

  -webkit-backdrop-filter: blur(16px);
  align-items: center;
  backdrop-filter: blur(16px);
  background: #fffdf4;
  border-bottom: 1px solid rgb(22 22 22 / 13%);
  box-sizing: border-box;
  color: #161616;
  display: flex;
  gap: 20px;
  height: var(--h);
  padding: 0 var(--inline);
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: var(--softmax-layer-navigation);
}

.brand {
  align-items: center;
  border-radius: 6px;
  color: inherit;
  display: flex;
  flex-shrink: 0;
  gap: 5px;
  outline: none;
}

.brand:focus-visible {
  box-shadow: inset 0 0 0 2px #161616;
}

.mark {
  display: block;
  height: 17px;
  pointer-events: none;
  width: auto;
}

/* The marketing nav's wordmark, at its size. */
.wordmark {
  display: block;
  height: 19.16px;
  pointer-events: none;
  width: 95.82px;
}

.nav {
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  margin-left: auto;
  min-width: 0;
}

/* THE LEAGUE BAR: the thin row a coworld adds under the header. */
.leagueBar {
  align-items: center;
  background: #fffdf4;
  border-bottom: 1px solid rgb(22 22 22 / 13%);
  border-top: 1px solid rgb(22 22 22 / 6%);
  box-sizing: border-box;
  display: flex;
  font:
    400 12px / 1 var(--font-plex-mono),
    monospace;
  gap: 8px;
  height: 32px;
  left: 0;
  padding: 0 var(--inline);
  position: absolute;
  right: 0;
  top: 100%;
}

.game {
  align-items: center;
  color: inherit;
  display: flex;
  flex-shrink: 0;
  gap: 6px;
  max-width: 40vw;
  text-decoration: none;
}

.gameIcon {
  border-radius: 4px;
  display: block;
  height: 18px;
  object-fit: cover;
  width: 18px;
}

.gameName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chevron {
  color: rgb(22 22 22 / 40%);
  flex-shrink: 0;
}

.leagues,
.leagueEnd {
  align-items: center;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.leagues {
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
}

.leagueEnd {
  flex-shrink: 0;
  gap: 2px;
  /* Its last row's text ends on the page margin, not its padding. */
  margin-right: -7px;
}

.leagues li {
  align-items: center;
  display: flex;
  flex-shrink: 0;
}

.leagues li + li::before {
  background: rgb(22 22 22 / 18%);
  content: "";
  height: 12px;
  margin: 0 3px;
  width: 1px;
}

.leagueBar .item {
  border-radius: 5px;
  color: rgb(22 22 22 / 62%);
  font-size: 12px;
  padding: 4px 7px;
  white-space: nowrap;
}

.leagueBar .item[aria-current="page"] {
  background: rgb(22 22 22 / 8%);
  color: #161616;
  font-weight: 500;
}

.leagueNote {
  color: rgb(22 22 22 / 55%);
  padding: 0 7px;
  white-space: nowrap;
}

.leagueRetry {
  background: none;
  border: 0;
  color: #161616;
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-decoration: underline;
}

.credits {
  color: rgb(22 22 22 / 55%);
  font:
    400 11px / 1 var(--font-plex-mono),
    monospace;
  padding: 8px 10px;
}

.searchIcon {
  align-items: center;
  display: flex;
}

.links {
  align-items: center;
  display: flex;
  gap: 20px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.slot {
  margin-bottom: -4px;
  padding-bottom: 4px;
  position: relative;
}

.menuTrigger {
  align-items: center;
  display: flex;
  max-width: 200px;
}

.menuTrigger .menuLabel {
  min-width: 0;
  overflow: hidden;
  padding-right: 2px;
  text-overflow: ellipsis;
}

.menuTrigger .menuArrow {
  flex-shrink: 0;
  padding-left: 2px;
}

.menuTrigger .menuButton {
  align-items: center;
  display: flex;
  gap: 4px;
}

.menuTrigger svg {
  flex-shrink: 0;
  transition: transform 200ms;
}

.menuTrigger [aria-expanded="true"] svg {
  transform: rotate(180deg);
}

.end {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 12px;
}

.link,
.navToggle {
  background: none;
  border: 0;
  border-radius: 8px;
  color: rgb(94 94 94);
  cursor: pointer;
  display: block;
  font:
    400 14px / 18px var(--font-plex-mono),
    monospace;
  letter-spacing: 0.01em;
  margin: 0;
  outline: none;
  padding: 8px 0;
  text-decoration: none;
  white-space: nowrap;
}

.action {
  border-radius: var(--softmax-radius-small);
  background: var(--softmax-color-action);
  color: #161616;
  cursor: pointer;
  display: block;
  font:
    400 13px / 17px var(--font-plex-mono),
    monospace;
  margin: 0;
  outline: none;
  padding: 9px 16px;
  text-decoration: none;
  white-space: nowrap;
}

.link[aria-expanded="true"],
.navToggle[aria-expanded="true"] {
  color: #161616;
}

.navToggle {
  display: none;
}

/* The user's avatar stays in front of the agent's avatar. */
.avatars {
  padding: 0;
}

.pair {
  display: flex;
}

.circle {
  --av: 28px;

  align-items: center;
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  font:
    500 12px / 1 var(--font-plex-mono),
    monospace;
  height: var(--av);
  justify-content: center;
  overflow: hidden;
  width: var(--av);
}

.circle img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.user {
  background: #fffdf4;
  border: 1px solid rgb(22 22 22 / 20%);
  position: relative;
  z-index: 1;
}

.back {
  background: #fffdf4;
  border: 1px solid rgb(22 22 22 / 20%);
  margin-left: calc(var(--av) * -0.375);
}

.link:focus-visible,
.navToggle:focus-visible {
  box-shadow: inset 0 0 0 2px #161616;
}

.action:focus-visible {
  outline: 2px solid #161616;
  outline-offset: 2px;
}

@media (hover: hover) {
  .link:hover,
  .navToggle:hover {
    color: #161616;
  }

  .action:hover {
    filter: brightness(0.95);
  }
}

/* A panel under the bar: a menu's dropdown under its button, the rest at the right edge. */
.dropdown,
.panel {
  animation: appear 200ms backwards;
  background: #fffdf4;
  border: 1px solid rgb(22 22 22 / 18%);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgb(22 22 22 / 12%);
  box-sizing: border-box;
  max-height: calc(100dvh - var(--site-header-height) - 16px);
  overflow-y: auto;
  padding: 8px;
  position: absolute;
  top: calc(100% + 4px);
}

.dropdown {
  right: 0;
  min-width: 200px;
  top: 100%;
}

.dropdownLeft {
  left: 0;
  right: auto;
  max-width: calc(100vw - 32px);
}

.panel {
  right: var(--inline);
  width: min(300px, calc(100vw - 32px));
}

.searchPanel {
  color: inherit;
  display: flex;
  flex-direction: column;
  gap: 6px;
  left: auto;
  margin: 0;
  width: min(360px, calc(100vw - 32px));
}

@keyframes appear {
  from {
    opacity: 0;
  }
}

.field {
  appearance: none;
  background: rgb(255 255 255 / 55%);
  border: 1px solid rgb(22 22 22 / 18%);
  border-radius: 10px;
  box-sizing: border-box;
  color: inherit;
  display: block;
  font:
    400 13px / 1 var(--font-plex-mono),
    monospace;
  height: 32px;
  margin: 0;
  outline: none;
  padding: 0 10px;
  width: 100%;
}

.field::placeholder {
  color: rgb(22 22 22 / 45%);
}

.field::-webkit-search-cancel-button {
  appearance: none;
}

.field:focus-visible {
  border-color: #161616;
}

.menu {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  background: none;
  border: 0;
  border-radius: 8px;
  box-sizing: border-box;
  color: inherit;
  cursor: pointer;
  display: block;
  font:
    400 13px / 1 var(--font-plex-mono),
    monospace;
  margin: 0;
  outline: none;
  padding: 8px 10px;
  text-align: left;
  text-decoration: none;
  white-space: nowrap;
  width: 100%;
}

.results {
  display: flex;
  flex-direction: column;
}

.results .item {
  overflow: hidden;
}

.label,
.secondary {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.secondary {
  color: rgb(22 22 22 / 55%);
  font-size: 12px;
  margin-top: 3px;
}

/* The row the arrows are on. */
.item.selected,
.item[aria-current="page"] {
  background: rgb(22 22 22 / 8%);
}

.note {
  color: rgb(22 22 22 / 55%);
  font:
    400 12px / 1.2 var(--font-plex-mono),
    monospace;
  padding: 6px 10px;
}

.all {
  border-top: 1px solid rgb(22 22 22 / 12%);
  border-radius: 0 0 8px 8px;
  margin-top: 6px;
}

.item:focus-visible {
  box-shadow: inset 0 0 0 2px #161616;
}

@media (hover: hover) {
  .item:hover {
    background: rgb(22 22 22 / 6%);
  }
}

.group {
  display: flex;
  flex-direction: column;
}

.heading {
  color: rgb(22 22 22 / 55%);
  font:
    400 11px / 1 var(--font-plex-mono),
    monospace;
  padding: 12px 10px 4px;
}

/* A long coworld name gives way before the bar overflows. */
.links .link {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Narrower, the site menus fold into one Menu button and its panel. */
@media (max-width: 1023px) {
  .bar {
    --gutter: 48px;
  }
}

@media (max-width: 767px) {
  .bar {
    --gutter: 20px;
  }
}

@media (max-width: 900px) {
  .links {
    display: none;
  }

  .navToggle {
    display: block;
  }
}

@media (max-width: 640px) {
  .bar {
    gap: 4px;
  }

  .link,
  .navToggle,
  .action {
    padding: 8px;
  }

  .panel {
    width: calc(100vw - 40px);
  }

  /* 16px, or iOS zooms the page into the field. */
  .field {
    font-size: 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .menuTrigger svg {
    transition: none;
  }

  .dropdown,
  .panel {
    animation: none;
  }
}

.item[aria-hidden],
.item[role="status"] {
  cursor: default;
  pointer-events: none;
}
